import { useEffect, useState, useMemo } from 'react';
import CommonService from '../services/common.service';

/**
 * `master_facility_sub_sub_type` for the selected sub-category (`facility_sub_type_id`).
 * GET /master/facility-sub-sub-types/:facilitySubTypeId
 */
export function useMasterFacilitySubSubTypes(facilitySubTypeId) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const parsedId = useMemo(() => {
    if (facilitySubTypeId == null || String(facilitySubTypeId).trim() === '') return null;
    const n = parseInt(String(facilitySubTypeId), 10);
    return Number.isNaN(n) ? null : n;
  }, [facilitySubTypeId]);

  useEffect(() => {
    let cancelled = false;
    if (parsedId == null) {
      setList([]);
      setLoading(false);
      setError(null);
      return;
    }
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const response = await CommonService.get(`/master/facility-sub-sub-types/${parsedId}`);
        if (cancelled) return;
        const body = response && typeof response === 'object' ? response : null;
        const raw = body && 'data' in body ? body.data : Array.isArray(response) ? response : [];
        setList(Array.isArray(raw) ? raw : []);
      } catch (e) {
        if (!cancelled) {
          setError(e);
          setList([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [parsedId]);

  return { list, loading, error, facilitySubTypeId: parsedId };
}
